import { motion, useReducedMotion } from 'framer-motion';

export const MaskedLines = ({ lines, className = '', lineClassName = '', delay = 0 }) => {
    const reduce = useReducedMotion();
    return (
        <span className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        initial={reduce ? false : { y: '112%' }}
                        animate={{ y: 0 }}
                        transition={{ duration: 1, delay: delay + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
};
